































































import axios from "axios";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import store from "@/store";

export default Vue.extend({
	components: {
		
	},
	props: ["data"],

	data() {
		return {

		};
	},

	created(){
		
	},

	methods: {
        hideModal() {
			this.$bvModal.hide("service-requirement-preview");
		},

        parseAnswer(situation: number){
            if(situation === 1){
                return "yes"
            }else if(situation === 2){
                return "service-requirement-modal.some-changes"
            }else if(situation === 3){
				return "service-requirement-modal.changes"
			}else{
				return "dash"
			}
        },

	},

	computed:{
		getCorrectLanguageChoices(){
			if(Object.keys(this.data).length <= 0){
				return [];
			}
			return this.data.palvelutarpeenArvioinninMuutosValinnat.map((r: any) => {
				if(this.$store.state.lang === 'en'){
					return {
						uid: r.uid,
						text: r.tekstiEnglanti
					}
				}else if(this.$store.state.lang === 'se'){
					return {
						uid: r.uid,
						text: r.tekstiRuotsi
					}
				}else{
					return {
						uid: r.uid,
						text: r.teksti
					}
				}
			})
		}
	}

});
